import React, { useEffect } from "react"
import { Box, styled } from "@mui/material"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { fetchPaymentMethods } from "redux/features/payment_methods/paymentMethodsThunk"
import {
  selectFetchCollectionStatus,
  selectPaymentMethods,
} from "redux/features/payment_methods/paymentMethodsSlice"
import { Progress } from "components/ui/Spinner"
import LoadableCollection from "components/ui/LoadableCollection"
import { PaymentMethodList } from "types"

export function withPaymentMethods<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithPaymentMethods = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const paymentMethods = useAppSelector((state) =>
      selectPaymentMethods(state),
    ) as PaymentMethodList
    const fetchStatus = useAppSelector((state) =>
      selectFetchCollectionStatus(state),
    )

    const handleFetchPaymentMethods = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchPaymentMethods())
      }
    }

    useEffect(() => handleFetchPaymentMethods(), [])

    const renderLoader = () => {
      return (
        <Container>
          <Progress color="primary" />
        </Container>
      )
    }

    return (
      <LoadableCollection
        fetchStatus={fetchStatus}
        renderLoading={renderLoader}
      >
        {() => (
          <WrappedComponent
            {...props}
            paymentMethods={paymentMethods}
            fetchStatus={fetchStatus}
            fetchPaymentMethods={handleFetchPaymentMethods}
          />
        )}
      </LoadableCollection>
    )
  }

  return WithPaymentMethods
}

const Container = styled(Box)`
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  top: calc(50% - 22.5px);
`
